// src/hooks/usePageTitle.js
import { useContext, useEffect, useRef } from 'react';
import { PageTitleContext } from '../layouts/MobileLayout';

export const usePageTitle = (title) => {
  const { setPageTitle } = useContext(PageTitleContext);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (setPageTitle && title) {
      setPageTitle(title);
      isInitialized.current = true;
    }
  }, [title, setPageTitle]);

  // Cleanup: resetear título cuando se desmonte el componente
  useEffect(() => {
    return () => {
      if (setPageTitle && isInitialized.current) {
        setPageTitle('Portal de Digitalización');
      }
    };
  }, [setPageTitle]);

  return setPageTitle;
};

export const usePageSubtitle = (subtitle) => {
  const { setPageSubtitle } = useContext(PageTitleContext) || {};

  useEffect(() => {
    if (!setPageSubtitle) return;
    const trimmed =
      subtitle != null && String(subtitle).trim() !== ''
        ? String(subtitle).trim()
        : null;
    setPageSubtitle(trimmed);
    return () => setPageSubtitle(null);
  }, [subtitle, setPageSubtitle]);
};
